<app-lock-screen></app-lock-screen>
<router-outlet></router-outlet>